var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgController = function SvgController(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.128 17.592a3.74 3.74 0 0 1-2.742-1.136Q7.25 15.32 7.26 13.717q-2.385.015-4.072-1.612T1.5 8.12q0-.705.503-1.209a1.65 1.65 0 0 1 1.209-.502h4.144V4.996H5.308v-1.5h5.586v1.5H8.856V6.41h3.29a1.8 1.8 0 0 1 1.265.517l8.135 8.086q.954.954.954 2.27 0 1.315-.954 2.269t-2.277.954-2.28-.954l-1.97-1.96zm-.012-3.875H8.744q-.009.99.684 1.682a2.3 2.3 0 0 0 1.697.693h2.394zm1.146-5.807h-9.05a.2.2 0 0 0-.15.062.2.2 0 0 0-.062.15q0 1.716 1.257 2.906t2.993 1.19h4.489l6.319 6.28a1.68 1.68 0 0 0 1.221.498q.714 0 1.217-.5T21 17.29t-.508-1.206z"
  })));
};
export default SvgController;